import { PLAYER } from "../../common/constants.ts";
import { g } from "../util/index.ts";

/** Current organization of a drafted player: minor leaguers (tid MINORS) belong to their minorTid, not to "no team". */
export const currentOrganization = (raw: { tid: number; minorTid?: number } | undefined, tid: number, abbrev: string) => {
	if (raw && raw.tid === PLAYER.MINORS && raw.minorTid !== undefined) {
		return {
			currentTid: raw.minorTid,
			currentAbbrev: g.get("teamInfoCache")[raw.minorTid]?.abbrev ?? abbrev,
			currentMinors: true,
		};
	}
	return { currentTid: tid, currentAbbrev: abbrev, currentMinors: false };
};
